<template>
  <div @click="goToTransactions" fluid class="px-8 pt-8" style="cursor: pointer; ">

    <div class="gradient-box d-flex" style="border-radius: 16px; box-shadow: none !important; height: 194px; padding: 20px;">
      <v-row no-gutters>
        <v-col cols="6" style="color: var(--text-over-primary);">
          <p class="text-body-1 pa-1 ml-2 mt-2 mb-0 pa-0" style="padding: 0px !important;">{{ $t("main.balance") }}</p>
          <p>
            <amount class="ml-2 mb-0 pa-0"  showDecimal :balance="balance" />
          </p>
        </v-col>
        <v-col cols="6" style="color: var(--text-over-primary);">
          <p class="text-body-1 pa-1 ml-2 mt-1 mb-0 pa-0" style=" margin-bottom: 0px !important; padding-bottom: 0px !important; text-align: end;">
            {{ $t("main.token") }}
          </p>
          <div
            class="d-flex align-center text-h4 font-weight-bold"
            style="
              color: var(--text-over-primary);
              min-height: min-content; 
              margin-top: 0px !important; 
              padding: 0;
              float: right;
            "
          >
            <!-- <v-img
              :src="tokensIcon"
              width="30"
              height="30"
              aspect-ratio="1"
              contain
              style="cursor: pointer"
              ></v-img> -->
              <icon
                :name="'tokens'"
                :color="'#fff'" 
                :style="'cursor: pointer;'"
                width="30"
              ></icon>
              <span>
                {{ tokens | getTotalTokens }}
              </span>
          </div>
        </v-col>
        <v-col cols="12" class="pt-10" style="color: var(--text-over-primary);">
          <p class="text-body-1 pa-2 ma-2">
            {{ eventName }}
          </p>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import Amount from "@/components/FormattedBalance";
import { mapState } from "vuex";

export default {
  data(){
    return {
      tokensIcon: require('@/assets/images/tokens_icon.png')
    }
  },
  props: {
    balance: Number,
    tokens: Array,
    routeNames: Object,
  },
  components: {
    Amount,
  },
  filters: {
    getTotalTokens(tokens) {
      return tokens.reduce((total, token) => {
        return total + token.amount;
      }, 0);
    },
  },
  computed: {
    ...mapState({
      eventName: (state) => state.customization.customization.name,
    }),
  },
  mounted() {
    const primaryColor = this.$vuetify.theme.themes.light.primary;

    const rgb = this.hexToRgb(primaryColor);
    if (rgb) {
      
      document.documentElement.style.setProperty('--primary-color-rgb', rgb);
    }
  },
  methods: {
    goToTransactions() {
      this.$router.push({
        name: this.routeNames.TRANSACTIONS,
        params: { showTransactionsWarningModal: true },
      });
    },
    hexToRgb(hex) {
      
      hex = hex.replace('#', '');
      if (hex.length === 3) {
        hex = hex.split('').map(c => c + c).join('');
      }
      const bigint = parseInt(hex, 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return `${r}, ${g}, ${b}`;
    }
  }
};
</script>

<style scoped lang="scss">
.gradient-box {
  background: linear-gradient(
    to top left,
    rgba(var(--primary-color-rgb), 0.6),
    var(--primary-color)
  );
}
.whole {
  font-size: 60px;
  &.small {
    font-size: 35px;
  }
}
</style>
